// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a21039aa","325":"16f3ec1c","455":"9bee4a85","496":"c2d89a67","581":"fed1e0c9"}[chunkId] + ".chunk.js";
};